const generateAdminUrl = tenant => {
  if (tenant === 'lx_indonesia') {
    return 'https://admin-id.luxola.com'
  } else if (tenant === 'lx_thailand') {
    return 'https://admin-th.luxola.com'
  } else if (tenant === 'lx_hongkong') {
    return 'https://admin.sephora.hk'
  } else if (tenant === 'lx_korea') {
    return 'https://admin.sephora.kr'
  } else {
    return 'https://admin.luxola.com'
  }
}

export {
  generateAdminUrl
}
